import { render, staticRenderFns } from "./ArticleTagsButton.vue?vue&type=template&id=480dec5a&"
import script from "./ArticleTagsButton.vue?vue&type=script&lang=ts&"
export * from "./ArticleTagsButton.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTagsButton.vue?vue&type=style&index=0&id=480dec5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports